import React, {Component} from 'react';

import formatter from '../../../../utils/formatters';
import ToggleInput from "../../../../components/ToggleInput/toggleInput";

export default class ProviderView extends Component {

    render() {

        let provider = this.props.item;
        if(!provider){return <div />}

        return (
            <div className={"admin-modal"}>
                <div className={"row"}>
                    <h3 className={"center"}>{provider.business_name}</h3>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">CUIT</label>
                        <p className={"field-p"}>{formatter.cuit(provider.cuit)}</p>
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 input-field"}>
                        <label className="active">Correo electrónico</label>
                        <p className={"field-p"}>{provider.email}</p>
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={provider.can_create_cif_trips}
                            name={'¿Puede crear viajes CIF?'} />
                    </div>
                    <div className={"col s12 input-field"}>
                        <ToggleInput
                            selected={provider.active}
                            name={'¿Proveedor activo?'} />
                    </div>
                </div>
                <div className={"row"}>
                    <div className={"col s12 center"}>
                        <button
                            className={"btn btn-shell-empty z-depth-0"}
                            onClick={this.props.closeAction}
                        >Cancelar</button>
                        <button
                            className={"btn btn-shell z-depth-0"}
                            onClick={() => this.props.editAction(provider, 'edit')}
                        >Editar</button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Admin/Modals/ProviderView.js